<!--Création d'offre ASW--------------------------------------------------------------------------------------------------------------------------------------------------------->						

<template>
	<v-container grid-list-md text-center>
		<v-layout wrap>
			<v-flex	xs12>
				<v-card color="grey lighten-5" height="auto">
					<v-card-title>
						<v-flex xs11 sm11 class="text-left">
							<h3>Créer offre ASW</h3>
						</v-flex>
					</v-card-title>
					<v-card-text>
						<v-container grid-list-md text-center>
							<v-layout wrap>
								<v-alert color="blue darken-2" class="white--text" type="info">Conversion via Netstore. Attention, tous les articles de l'offre doivent être 
									actifs dans Netstore pour que la création de l'offre ASW fonctionne.
								</v-alert>
								<v-flex xs12 sm5>
									<p class="text-left">Sélectionnez l'offre à convertir :</p>
									<v-autocomplete  
										v-model="$store.state.quotationReference" 
										label="N° d'offre Conectis" 
										:placeholder="$store.state.quotationNumberToASW"
										:items="$store.state.quotations" 
										filled
										v-on:change="loadQuotation($store.state.quotationReference)">
									</v-autocomplete>
								</v-flex>
								<v-flex xs12 sm5 offset-1>
									<p class="text-left">Collez un n° de session Netstore valide (*):</p>
									<v-text-field
										v-model="netstoreSession"
										label="N° de session Netstore"
										filled
									></v-text-field>
								</v-flex>
								<v-flex xs12>
									<div  v-if="($store.state.quotationReference!=null || $store.state.quotationNumberToASW!=null) && netstoreSession.length==32">
										<v-btn class="ma-2 d-flex align-start" color="blue"
											@click="quotationConvert($store.state.ConectisQuotation[0].QUOTATION_NUMBER, netstoreSession)" dark>
											<v-icon left>mdi-file-swap</v-icon>
											Convertir l'offre {{ $store.state.ConectisQuotation[0].QUOTATION_NUMBER }}
										</v-btn>
										<v-flex v-if="$store.state.is_loading">
											<v-progress-linear :indeterminate="true"></v-progress-linear>
										</v-flex>
										<v-flex class="text-xs-center mt-3" v-if="$store.state.convertOk">
											<v-alert class="white--text" v-if="$store.state.netstoreReport.ok" type="success" height="auto">
												<v-row>
													<h4>N° d'offre ASW générée : {{ $store.state.netstoreReport.quotationNumber }}<br>
														Veuillez la copier pour votre client. !!! Prix !!! 
													</h4>
													<v-spacer></v-spacer>
													<v-chip color="orange" v-if="$store.state.netstoreReport.horsCatalogue==1">Attention, l'offre contient un article hors catalogue, donc non-importé !</v-chip>
													<v-chip color="orange"  v-if="$store.state.netstoreReport.horsCatalogue>1">Attention, l'offre contient {{ $store.state.netstoreReport.horsCatalogue }} articles hors catalogue, donc non-importés !</v-chip>
												</v-row>
											</v-alert>
											<v-alert class="white--text" v-if="!$store.state.netstoreReport.ok && $store.state.netstoreReport.error!=null" type="error" height="auto">
												<h4>Erreur ! L'offre n'a pas été convertie en ASW.</h4>
												Réponse de Netstore :
												<ul>
													<li style="list-style-type:none;" v-for="error in $store.state.netstoreReport.error" v-bind:key="error">{{ error }}</li>
												</ul>
											</v-alert>
										</v-flex>
									</div>
									<div v-if="$store.state.quotationReference!=null || $store.state.quotationNumberToASW!= null">
										<v-card-title>
											<h5>Offre {{ $store.state.quotationNumberToASW }} : {{ $store.state.ConectisQuotation[0].QUOTATION_TITLE }}</h5>
										</v-card-title>

										<v-data-table
											:headers="this.$store.state.QuotationsHeaders"
											:items="$store.state.ConectisQuotation"
											:items-per-page="10"
											class="elevation-1"
										></v-data-table>
									</div>
								</v-flex>
							</v-layout>
						</v-container>
					</v-card-text>
				</v-card>
			</v-flex>
		</v-layout>
	</v-container>

</template>
<script>
	import axios from 'axios';

	export default {
		name: "RechercheParNoOffre",

		data: function () {
			return {
				designationDialog: false,
				netstoreSession: "",
				searchQuotations: null,

				InfoDesignationHeaders: [
					{ text: 'Operator', value: 'OPERATOR' },
					{ text: 'Description', value: 'DESCRIPTION' },
					{ text: 'Example', value: 'EXAMPLE' },
				],
            }
        },
		methods: {
			quotationConvert: function (quotationReference, session) {
				this.$store.state.convertOk = false;
				var link = "http://domoserver.ddns.net/gigamedia1/quotationConvert.php?quotationNumber=" + encodeURIComponent(quotationReference) + "&netstoreSession=" + session;
				axios.get(link).then(response => {
					this.$store.state.netstoreReport = response.data;
					this.$store.state.convertOk = true;
				});
			},
        }
    }
</script>
